import React from 'react';
import {
  FormControl as MuiFormControl,
  formHelperTextClasses,
  inputBaseClasses,
} from '@mui/material';
import styled from '@emotion/styled';
import theme from 'src/theme';

const StyledFormControl = styled(MuiFormControl)(() => ({
  minHeight: theme.spacing(6.5),
  [`& .${inputBaseClasses.input}`]: {
    padding: `${theme.spacing(1)} !important`,
    textAlign: 'right',
    // text
    // [`& .${inputBaseClasses.}`]: {

    // }
  },
  [`& .${formHelperTextClasses.root}`]: {
    margin: 0,
    lineHeight: 1.1,
  },
}));

export default StyledFormControl;
